import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import './output.css';
import App from './App';
import EmailViewer from './email/EmailViewer';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/email" element={<EmailViewer />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();